var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPedestrian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 98,
    viewBox: "0 0 102 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.8477 21.0395C55.3179 21.7187 60.3031 17.8348 60.9823 12.3645C61.6615 6.89421 57.7776 1.90906 52.3073 1.22984C46.8371 0.550618 41.8519 4.43453 41.1727 9.90481C40.4935 15.3751 44.3774 20.3602 49.8477 21.0395Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8176 22.6576L55.5418 24.2208C57.8867 24.2208 59.4499 26.5657 59.4499 28.9105C58.2775 38.2898 58.6683 44.1519 66.4844 50.014C70.3925 53.1405 66.0936 59.0026 62.1855 55.8761C59.8407 54.3129 58.2775 52.3589 56.7142 50.4048C56.3234 52.7497 55.9326 55.0945 53.197 55.8761C61.0131 64.4739 66.4844 75.4164 68.0476 86.7498C68.8292 92.6119 59.4499 93.7843 58.6683 87.9222C57.8867 79.7153 54.3694 71.8992 49.2889 65.2555C45.7717 74.244 41.082 82.4509 34.8291 90.2671C30.921 94.9567 23.8865 89.0946 27.7946 84.405C34.4383 76.198 38.7372 67.2095 42.2544 57.8301C39.9096 55.4853 35.6107 52.7497 36.0015 49.6232L37.9556 33.991C33.2659 37.899 30.5302 42.5887 30.1394 49.2324C29.7486 54.3129 22.3233 53.9221 22.7141 48.8416C23.4957 36.3358 30.5302 28.5197 41.082 23.0484C41.8636 22.6576 42.6452 22.2668 43.8176 22.6576Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 96H102",
    stroke: "url(#paint0_linear_4_38)",
    strokeWidth: 4,
    strokeDasharray: "8 8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_38",
    x1: -1.30156,
    y1: 96.4273,
    x2: 0.120721,
    y2: 110.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309653,
    stopColor: "#EA50E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965,
    stopColor: "#FAFF00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPedestrian);
export default __webpack_public_path__ + "static/media/pedestrian.e7223f991d5fdb082dd7dbd95c8b8ed6.svg";
export { ForwardRef as ReactComponent };